import { MutationTree } from "vuex/types"
import { LayoutServiceData } from "@sitecore-jss/sitecore-jss"

import { JssState } from "./types"

const mutations: MutationTree<JssState> = {
  setLayoutResponse (state, layout: LayoutServiceData) {
    const {
      sitecore: { route, context = {} }
    } = layout

    // Do not replace the original state object - the store and any components that use the store
    // need to share a reference to the same object in order for mutations to be observed.
    state.statusCode = '200'
    state.route = route
    state.context = context
  },

  setLayoutError (state, statusCode: string) {
    state.statusCode = statusCode
    state.route = null
    state.context = null
  },

  setIntegrationMode (state, b = true) {
    state.isExperienceEditor = b
  }
}

export default mutations
